import { React, useEffect, useState, Fragment, useCallback, useMemo, useRef } from "react";
import { createComponentCycle, getCycles,genericPost,genericGet } from "../../services/Api";
 

import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import cogoToast from "cogo-toast";
import * as SurveyCore from "survey-core";
import "survey-creator-core/survey-creator-core.min.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { SUCCESS_RESULT, ENDPOINTS, DEFAULT_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import reactRouterDom, { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
import { Survey } from 'survey-react-ui'; 
import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import makeAnimated from 'react-select/animated';
import "survey-react/survey.css";
 
 

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap";

const CYCLE_SURVEY_TEMPLATE = {
    "logoPosition": "right",
    "pages": [
     {
      "name": "page1",
      "elements": [
       {
        "type": "text",
        "name": "name",
        "title": "Cycle Name"
       },
       {
        "type": "text",
        "name": "start_date",
        "startWithNewLine": false,
        "title": "Start Date",
        "inputType": "date"
       },
       {
        "type": "text",
        "name": "end_date",
        "startWithNewLine": false,
        "title": "End Date",
        "inputType": "date"
       },
       {
        "type": "matrixdynamic",
        "name": "entitlement",
        "title": "Enter the items to redeem",
        "defaultValue": {
         "Cash": {
          "pos": {
           "pos": {
            "pos": {
             "pos": {
              "start": 778,
              "end": 846
             },
             "start": 684,
             "end": 912
            },
            "start": 235,
            "end": 975
           },
           "start": 230,
           "end": 1060
          },
          "price": 4800,
          "qty": 1,
          "total": 4800
         }
        },
        "isRequired": true,
        "columns": [
         {
          "name": "name"
         },
         {
          "name": "qty",
          "title": "qty",
          "cellType": "text",
          "isRequired": true,
          "inputType": "number"
         },
         {
          "name": "price",
          "title": "price",
          "cellType": "text",
          "isRequired": true
         },
         {
          "name": "total",
          "title": "total",
          "cellType": "expression",
          "isRequired": true,
          "totalDisplayStyle": "currency",
          "expression": "{row.qty} * {row.price}",
          "displayStyle": "currency"
         }
        ],
        "choices": [
         1,
         2,
         3,
         4,
         5
        ],
        "cellType": "text"
       },
       {
        "type": "matrixdynamic",
        "name": "tacking_info",
        "title": "Tracking info",
        "defaultValue": {
         "Cash": {
          "pos": {
           "pos": {
            "pos": {
             "pos": {
              "start": 2144,
              "end": 2212
             },
             "start": 684,
             "end": 2278
            },
            "start": 235,
            "end": 2341
           },
           "start": 230,
           "end": 2426
          },
          "price": 4800,
          "qty": 1,
          "total": 4800
         }
        },
        "columns": [
         {
          "name": "parameter_name"
         },
         {
          "name": "parameter_type",
          "title": "parameter_type",
          "cellType": "dropdown",
          "isRequired": true,
          "choices": [
           "Text",
           "Number",
           "Date"
          ],
          "storeOthersAsComment": true
         }
        ],
        "choices": [
         1,
         2,
         3,
         4,
         5
        ],
        "cellType": "text",
        "rowCount": 0
       },
       {
        "type": "dropdown",
        "name": "cva_enabled",
        "title": "is CVA Enabled?",
        "choices": [
         {
          "value": "10000",
          "text": "No"
         },
         {
          "value": "10001",
          "text": "Yes"
         }
        ]
       }
      ]
     }
    ]
};

const parseJsonField = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

const formatDateForInput = (value) => {
  if (!value) return "";
  const s = String(value);
  return s.includes(" ") ? s.split(" ")[0] : s.slice(0, 10);
};

const mapEntitlementRows = (raw) => {
  const entitlement = parseJsonField(raw);
  if (!entitlement) return [];
  if (Array.isArray(entitlement)) {
    return entitlement.map((row) => ({
      name: row?.name || "",
      qty: Number(row?.qty ?? 0),
      price: Number(row?.price ?? 0),
      total: Number(row?.total ?? Number(row?.qty ?? 0) * Number(row?.price ?? 0)),
    }));
  }
  return Object.entries(entitlement).map(([name, item]) => ({
    name,
    qty: Number(item?.qty ?? 0),
    price: Number(item?.price ?? 0),
    total: Number(item?.total ?? Number(item?.qty ?? 0) * Number(item?.price ?? 0)),
  }));
};

const mapTrackingRows = (raw) => {
  const tacking = parseJsonField(raw);
  if (!tacking) return [];
  if (Array.isArray(tacking)) {
    return tacking.map((row) => ({
      parameter_name: row?.parameter_name || row?.name || "",
      parameter_type: row?.parameter_type || row?.type || "Text",
    }));
  }
  return Object.entries(tacking).map(([key, val]) => {
    if (val && typeof val === "object" && (val.parameter_name || val.parameter_type)) {
      return {
        parameter_name: val.parameter_name || key,
        parameter_type: val.parameter_type || "Text",
      };
    }
    return {
      parameter_name: key,
      parameter_type: typeof val === "string" ? val : "Text",
    };
  });
};

const buildCycleFormData = (data) => ({
  name: data?.cycle_name || data?.name || "",
  start_date: formatDateForInput(data?.start_date),
  end_date: formatDateForInput(data?.end_date),
  entitlement: mapEntitlementRows(data?.entitlement),
  tacking_info: mapTrackingRows(data?.tacking_info),
  cva_enabled:
    data?.cva_enabled != null && data?.cva_enabled !== ""
      ? String(data.cva_enabled)
      : "",
});

SurveyCore.StylesManager.applyTheme("darkblue");

const ComponentCycles = (props) => {
  const history = useHistory();
  const { component } = (props.location && props.location.state) || {};
  const [isLoading, setIsLoading] = useState(false);
  const [cycles, setCycles] = useState([]);
  const [beneficiaries, setbeneficiaries] = useState([]);
  const creator = new SurveyCreator({ showLogicTab: false });
  const animatedComponents = makeAnimated();
  const [editingCycleId, setEditingCycleId] = useState(null);
  const [editingCycleName, setEditingCycleName] = useState("");
  const [surveyModel, setSurveyModel] = useState(null);
  const [surveyFormKey, setSurveyFormKey] = useState(0);
  const editingCycleIdRef = useRef(null);
  const submitCycleRef = useRef(null);
  const [permissions, setPermissions] = useState(null);
  const [users, setUsers] = useState(null);

   const [selectedPermissions, setSelectedPermissions] = useState([])
   const [selectedUsers, setSelectedUsers] = useState([])


   const [showPermissionsModal, setShowPermissionsModal] = useState(false)
   const toggle = () => setShowPermissionsModal(!showPermissionsModal);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [cycleToDelete, setCycleToDelete] = useState(null);
  const [isDeletingCycle, setIsDeletingCycle] = useState(false);
  useEffect(() => {
    console.clear();
    console.log(component)
    listCycles();
    listUsers();
    return () => { };
  }, []);


  const getPermissions = (_id) => {
    setIsLoading(true);
    genericGet(ENDPOINTS.LIST_PERMISSIONS_TO_ASSIGN+"?resource_id="+_id)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            setPermissions(responseData);
            setShowPermissionsModal(true);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };


    const handlePaste = (event) => {
   
    const pasteData = event.clipboardData.getData('text');
    const values = pasteData.split(',').map(val => val.trim()).filter(Boolean);
    
     const newOptions = values.map(value => ({ label: value, value: get_user_id(value) }));
 
    setSelectedUsers(prev => [...prev, ...newOptions]);
    event.preventDefault();
  };

 const get_user_id = (value) => {
    let user_id = null;
    users.forEach((user) => {
      if (user.label.toLowerCase().includes(value.toLowerCase())) {
        user_id = user.value;
      }
    });
    return user_id;
  };
  const handleChange = (selected) => {
    setSelectedUsers(selected || []);
  };

  const listUsers = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.LIST_ACTIVE_USERS)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            var usrs = JSON.parse(JSON.stringify(responseData).split('"text":').join('"label":'));
            setUsers(usrs);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const submitCycle = (form_result) => {
    const data = { ...form_result.valuesHash };
    const cycleId = editingCycleIdRef.current;

    data.project_id = component?.project_id || component?.project?.id;
    data.cycle_id = cycleId;
    data.components_id = component?.id;
    data.assigned_components_id = component?.assigned_component_id;

    setIsLoading(true);
    createComponentCycle(data)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            form_result.clear();
            setEditingCycleId(null);
            setEditingCycleName("");
            editingCycleIdRef.current = null;
            cogoToast.success(cycleId ? "Cycle updated successfully" : "Cycle created successfully", {});
            listCycles();
            clearCycleForm();
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {});
      });
  };
  submitCycleRef.current = submitCycle;

  const createSurveyModelInstance = (formData = {}, cycleIdForEdit = null) => {
    const model = new SurveyCore.Model(CYCLE_SURVEY_TEMPLATE);
    model.showCompletedPage = false;
    model.data = formData;
    model.onCompleting.add((sender, options) => {
      submitCycleRef.current?.(sender);
      options.allowComplete = false;
    });
    editingCycleIdRef.current = cycleIdForEdit;
    return model;
  };

  const clearCycleForm = () => {
    setEditingCycleId(null);
    setEditingCycleName("");
    editingCycleIdRef.current = null;
    setSurveyModel(createSurveyModelInstance({}, null));
    setSurveyFormKey((k) => k + 1);
  };

  const loadCycleIntoForm = (data) => {
    if (!data) return;
    const formData = buildCycleFormData(data);
    const cycleId = data.cycle_id || data.id || null;
    setEditingCycleId(cycleId);
    setEditingCycleName(data.cycle_name || data.name || "");
    setSurveyModel(createSurveyModelInstance(formData, cycleId));
    setSurveyFormKey((k) => k + 1);
    setTimeout(() => {
      document.getElementById("cycle-form-section")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  useEffect(() => {
    setSurveyModel(createSurveyModelInstance({}, null));
  }, []);

  const AssignAccessRights = () => {
    const data = [];
    selectedUsers.forEach((user) => {
      selectedPermissions.forEach((perm) => {
        data.push({
          user_id: user.value,
          module_permission_id: perm.value,
          status: 10001,
          is_updating: 1,
        });
      });
    });

    genericPost(ENDPOINTS.UPDATE_ACCESS_PERMISSION, data)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setShowPermissionsModal(false);
            cogoToast.success(res.data.message, {});
          } else {
            cogoToast.error(res.data.message, {});
            setShowPermissionsModal(false);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const promptDeleteCycle = (cycle) => {
    if (!cycle?.cycle_id) return;
    setCycleToDelete(cycle);
    setShowDeleteModal(true);
    setOpenActionMenu(null);
  };

  const closeDeleteModal = () => {
    if (isDeletingCycle) return;
    setShowDeleteModal(false);
    setCycleToDelete(null);
  };

  const deleteCycle = () => {
    if (!cycleToDelete?.cycle_id) {
      cogoToast.error("Cycle information is missing.", {});
      return;
    }

    setIsDeletingCycle(true);
    genericPost(ENDPOINTS.DELETE_COMPONENT_CYCLE, {
      cycle_id: cycleToDelete.cycle_id,
    })
      .then((res) => {
        setIsDeletingCycle(false);
        if (
          res?.status === 200 &&
          (res?.data?.status === SUCCESS_RESULT || res?.data?.status === DEFAULT_RESULT)
        ) {
          cogoToast.success(res?.data?.message || "Cycle deleted successfully.", {});
          if (editingCycleId === cycleToDelete.cycle_id) {
            clearCycleForm();
          }
          setShowDeleteModal(false);
          setCycleToDelete(null);
          listCycles();
        } else {
          cogoToast.error(res?.data?.message || "Failed to delete cycle.", {});
        }
      })
      .catch((err) => {
        setIsDeletingCycle(false);
        console.error("Delete cycle error", err);
        cogoToast.error("Failed to delete cycle.", {});
      });
  };

  const listCycles = () => {
    setIsLoading(true);

    getCycles({ component_id: component?.id })
      .then((res) => {
        if (res.status == 200) {
          console.log(res);

          if (res.data.status == SUCCESS_RESULT) {

            setCycles(res.data.data);
            setIsLoading(false);
         
          } else {
         
         
            setIsLoading(false);
            cogoToast.error(res.data.message, {
              position: "top-right",
              hideProgressBar: false,
              closeOnClick: true,
              draggable: true,
            });
         
         
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          position: "bottom-right",
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
        });
      });
  };

  return (
    <div>     <div className="row w-80">
      <h1>PROJECT COMPONENT CYCLES</h1>
      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/ebms"> EBMS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/projects"> Components Cycles </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <Link to="#"> {component?.name || "Component"} </Link>
        </BreadcrumbItem>
      </Breadcrumb>
 
      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div>


        <div className="col-md-12">
          <div
            className="d-flex justify-content-between align-items-center flex-wrap mb-2"
            style={{ gap: 8 }}
          >
            <h3 style={{ marginBottom: 0 }}>Cycles for {component?.name || "Component"}</h3>
            <button className="btn btn-success btn-sm" onClick={() => getPermissions(component?.id)}>
              Component Permissions
            </button>
          </div>

          <Table hover bordered className="bg-white shadow-sm">
            <thead className="table-dark">
              <tr>
                <th>Cycle Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th style={{ width: 180 }}>Actions</th>

              </tr>
            </thead>
            <tbody>
              {cycles?.map((c, i) => {
                // let patient=JSON.parse(p.beneficiary_details);

                return (
                  <tr key={i}>
                    <td>
                      <span className="align-middle fw-bold">
                        {" "}
                        {c.cycle_name}{" "}
                      </span>
                    </td>
                    <td> {c.start_date} </td>
                    <td> {c.end_date} </td>
<td>
  <Dropdown
    isOpen={openActionMenu === c.cycle_id}
    toggle={() => setOpenActionMenu(openActionMenu === c.cycle_id ? null : c.cycle_id)}
  >
    <DropdownToggle caret color="primary" size="sm" className="w-100">
      Actions
    </DropdownToggle>
    <DropdownMenu end strategy="fixed" style={{ zIndex: 3000 }}>
      <DropdownItem
        onClick={() => {
          loadCycleIntoForm(c);
          setOpenActionMenu(null);
        }}
      >
        Fill Form
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          loadCycleIntoForm(c);
          setOpenActionMenu(null);
        }}
      >
        Edit
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          getPermissions(c.cycle_id);
          setOpenActionMenu(null);
        }}
      >
        Permissions
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          history.push({
            pathname: "/projects/cycle-distributions",
            state: { cycle_id: c.cycle_id, cycle_name: c.cycle_name },
          });
          setOpenActionMenu(null);
        }}
      >
        Distributions
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          history.push({
            pathname: "/projects/missing-cycle-distributions",
            state: { cycle_id: c.cycle_id, cycle_name: c.cycle_name },
          });
          setOpenActionMenu(null);
        }}
      >
        Missing Distributions
      </DropdownItem>
      <DropdownItem
        onClick={() => {
          history.push({
            pathname: `/projects/beneficiary-clockings/${c.cycle_id}`,
            state: { cycle_id: c.cycle_id, cycle_name: c.cycle_name },
          });
          setOpenActionMenu(null);
        }}
      >
        View Clockins
      </DropdownItem>
      <DropdownItem divider />
      <DropdownItem
        className="text-danger"
        onClick={() => promptDeleteCycle(c)}
      >
        Delete
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</td>
              
               
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

   
   
        <div className="col-md-12" id="cycle-form-section">
          <hr></hr>
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-2" style={{ gap: 8 }}>
            <h3 style={{ marginBottom: 0 }}>
              {editingCycleId ? `Edit Cycle: ${editingCycleName}` : "Cycle Information"}
            </h3>
            {editingCycleId && (
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={clearCycleForm}>
                New Cycle
              </button>
            )}
          </div>

          {!isLoading && surveyModel && (
               <Survey key={surveyFormKey} model={surveyModel} />
          )}

<br/>

<Modal
        isOpen={showPermissionsModal}
        size="lg"
        backdrop={true}
      >
        <ModalHeader toggle={toggle} style={{ padding: '0.75rem 1rem' }}>
          <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>
            Assign Cycle Permissions
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: '1rem' }}>
<div style={{ fontSize: '0.9rem' }}>
{/* Current Users with Permissions Card */}
{permissions && (() => {
  // Extract all unique users from permissions
  const allUsers = [];
  const userMap = new Map(); // Use Map to track unique users by email
  
  permissions.forEach((perm) => {
    if (perm.users && Array.isArray(perm.users)) {
      perm.users.forEach((user) => {
        if (user.email && !userMap.has(user.email)) {
          userMap.set(user.email, user);
          allUsers.push(user);
        }
      });
    }
  });

  return allUsers.length > 0 ? (
    <div className="card mb-2" style={{ border: '1px solid #dee2e6', borderRadius: '0.25rem' }}>
      <div className="card-header" style={{ backgroundColor: '#f8f9fa', fontWeight: '600', padding: '0.5rem 0.75rem', fontSize: '0.9rem' }}>
        Current users with permissions
      </div>
      <div className="card-body" style={{ padding: '0.5rem 0.75rem', maxHeight: '150px', overflowY: 'auto' }}>
        <div className="row" style={{ margin: '0' }}>
          {allUsers.map((user, index) => (
            <div key={index} className="col-md-6" style={{ padding: '0.25rem 0.5rem', marginBottom: '0.25rem' }}>
              <div style={{ padding: '4px 6px', backgroundColor: '#f8f9fa', borderRadius: '3px', fontSize: '0.85rem' }}>
                <div style={{ fontWeight: '600', fontSize: '0.85rem', lineHeight: '1.3' }}>{user.name || 'N/A'}</div>
                <div style={{ color: '#6c757d', fontSize: '0.75rem', lineHeight: '1.2' }}>{user.email || 'N/A'}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null;
})()}

<h5 style={{ marginTop: '0.5rem', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: '600' }}>Permissions</h5>
{permissions && (
  <div style={{ marginBottom: '0.75rem' }}>
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      onChange={setSelectedPermissions}
      options={permissions}
      styles={{
        control: (base) => ({ ...base, minHeight: '32px', fontSize: '0.875rem' }),
        menu: (base) => ({ ...base, fontSize: '0.875rem' }),
        multiValue: (base) => ({ ...base, fontSize: '0.8rem' }),
        multiValueLabel: (base) => ({ ...base, fontSize: '0.8rem', padding: '2px 6px' }),
        multiValueRemove: (base) => ({ ...base, padding: '2px' })
      }}
    />
  </div>
)}
<hr style={{ margin: '0.75rem 0' }}/>

        <div style={{ marginBottom: '0.75rem' }}>
          <CreatableSelect
            isMulti
            onChange={handleChange}
            options={users}
            value={selectedUsers}
            onPaste={handlePaste}
            placeholder="Paste comma-separated values..."
            styles={{
              control: (base) => ({ ...base, minHeight: '32px', fontSize: '0.875rem' }),
              menu: (base) => ({ ...base, fontSize: '0.875rem' }),
              multiValue: (base) => ({ ...base, fontSize: '0.8rem' }),
              multiValueLabel: (base) => ({ ...base, fontSize: '0.8rem', padding: '2px 6px' }),
              multiValueRemove: (base) => ({ ...base, padding: '2px' })
            }}
          />
        </div>

    <textarea
      onPaste={handlePaste}
      placeholder="Paste comma-separated values..."
      style={{ width: '100%', height: '60px', fontSize: '0.875rem', padding: '0.5rem', marginBottom: '0.75rem' }}
    />

    <div style={{ fontSize: '0.85rem', marginBottom: '0.75rem', color: '#6c757d' }}>
      Selected users: {selectedUsers.length}
    </div>
    <button className="btn btn-primary btn-sm" onClick={()=>AssignAccessRights()} style={{ fontSize: '0.875rem', padding: '0.375rem 0.75rem' }}>
      Save Permissions
    </button>
</div>
        </ModalBody>
      
      </Modal>

      <Modal isOpen={showDeleteModal} toggle={closeDeleteModal} centered>
        <ModalHeader toggle={closeDeleteModal}>Delete Cycle</ModalHeader>
        <ModalBody>
          Are you sure you want to delete{" "}
          <strong>{cycleToDelete?.cycle_name || "this cycle"}</strong>?
          <div className="text-muted small mt-2">This action cannot be undone.</div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeDeleteModal} disabled={isDeletingCycle}>
            Cancel
          </Button>
          <Button color="danger" onClick={deleteCycle} disabled={isDeletingCycle}>
            {isDeletingCycle ? (
              <>
                <Spinner size="sm" className="me-2" />
                Deleting...
              </>
            ) : (
              "Delete Cycle"
            )}
          </Button>
        </ModalFooter>
      </Modal>


 


   
        </div>

     
      </div>
    </div>
  );
};

export default ComponentCycles;
